module.exports = __webpack_public_path__ + "static/media/security.f4642cb2.svg";